module.exports = __webpack_public_path__ + "img/vuetify.31b0d032.svg";